<main class="content">
  <section class="intro">
    <h1 class="font-extrabold">How to find and redeem gifts</h1>
    <p paint="light" class="font-light">Have you won a gift through the cloudigo app?</p>
  </section>

  <br><br>

  <section class="guide">
    <div>
      <div class="orb" paint="accent">
        <span></span>
        <h1 class="font-extrabold">1</h1>
      </div>
      <p paint="light" class="font-light">Open the cloudigo app and click on the indicated <span bold>Wallet</span> icon in the top right corner.
      </p>
      <br/>
      <img src="old/how-tos/voucher-use-1.webp" alt="Step 1" />
    </div>
    <div>
      <div class="orb" paint="primary">
        <span></span>
        <h1 class="font-extrabold">2</h1>
      </div>
      <p paint="light" class="font-light">Scroll left to the <span bold>Vouchers</span> tab - here you will be able to see all your available, used and expired gifts. To redeem an available gift, click on <span bold>‘Redeem’</span>. 
      </p>
      <br/>
      <img src="old/how-tos/voucher-use-2.webp" alt="Step 2" />
    </div>
    <div>
      <div class="orb" paint="warn">
        <span></span>
        <h1 class="font-extrabold">3</h1>
      </div>
      <p paint="light" class="font-light">
        Visit the store/restaurant to redeem your gift. <span bold>Scan the QR code</span> provided by the merchant and you’re done!
      </p>
      <br/>
      <img src="old/how-tos/voucher-use-3.webp" alt="Step 3" />
    </div>
  </section>

  <section class="outro">
    <p paint="light" class="font-light">For more information, please send us an email on <a href="mailto:support@cloudigo.app"
        paint="primary">support&#64;cloudigo.app</a> or talk to us on <a target="_top" rel="noreferrer" href="https://www.facebook.com/cloudigo"
        paint="primary">Facebook</a>.</p>

    <a mat-flat-button class="premium-horizontal" routerLink="/builder" [queryParams]="queryParams">Find your gifts</a>

  </section>
</main>